import { render } from "./AppFooter.vue?vue&type=template&id=231276eb&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=231276eb&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1682218388/src/website-PressPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231276eb"]])

export default __exports__